export const news = {
  headerTitle: "NEWS",
  purchaseFirstTitle: "初回購入限定！",
  purchaseFirstDesc: "ポイント増量✨",
  purchaseSecondTitle: "2回目購入限定！",
  purchaseSecondDesc: "30%お得🉐",
  purchaseThirdTitle: "3回目購入限定！",
  purchaseThirdDesc: "800ptお得🉐",
  purchaseFourthTitle: "4回目購入限定！",
  purchaseFourthDesc: "1000pt増量✨",
  purchaseFifthTitle: "5回目購入限定！",
  purchaseFifthDesc: "ポイント増量✨",
  webPaymentTitle: "ApplePayやクレジットカードでの決済が可能に！",
  webPaymentDesc: "購入画面はこちら🌟",
  dailyBonusTitle: "ポイント購入で毎日がお得に！",
  dailyBonusDesc: "デイリーボーナスが毎日2倍！",
  lovenseTitle: "遠隔操作で",
  lovenseDesc: "ビデオ通話を楽しもう♪",
  findTypeGirlTitle: "好みの女の子が見つかりやすい！",
  findTypeGirlDesc: "さがす画面はこちら✨",
  searchGirlsTitle: "好みの女の子とマッチ率UP！",
  searchGirlsDesc: "検索機能はこちら🔍",
  reviewRewardTitle: "レビューを書いて50Pゲット！",
  reviewRewardDesc: "レビュー投稿はこちら📝",
  spuPointBackTitle: "ポイントバックキャンペーン実施中！",
  spuPointBackDesc: "毎週最大3000ptポイントバック！",
  campaignEimiPointBackTitle: "超ポイント還元祭！",
  campaignEimiPointBackDesc: "最大6,000pt還元！10/23(金)10:00まで",
  missionMakingCallTitle: "ビデオ通話ミッション開催中！",
  missionMakingCallDesc: "最大20,000pt貰える💕",
  eimiSummary: {
    title: "深田えいみコラボイベント開催中！！",
    period: (args: { start: string; end: string }) =>
      `キャンペーン期間：${args.start}〜${args.end}`,
    imageAlt: "深田えいみコラボ開催中",
    caption: "深田えいみが着用した服をキャンペーンでゲットしよう♥",
    consumedPointLabel: "消費ポイント",
    pointBackLabel: "還元予定ポイント",
    pointBackMax: (args: { max: string | number }) => `最大${args.max}pt還元`,
    lotteryLabel: "抽選状況",
    lotteryUnit: "口",
    lotteryNext: (args: { point: string | number }) =>
      `次の1口まで あと${args.point}pt`,
    rankingLabel: "あなたの現在順位",
    rankingCaption: "ポイント消費ランキング",
    rankingOut: "圏外",
    rankingUnit: "位",
    pointUnit: "pt",
    detailButton: "キャンペーン詳細はこちら",
  },
} as const;
